import moment from 'moment';
import { comparisonOptionNames } from '../models';

const format = 'DD.MM.YYYY';

const comparisonDaterangeToString = ({ option, startDate, endDate }) => {
  if (option === comparisonOptionNames.custom) {
    return `${moment.unix(startDate).format(format)} - ${moment.unix(endDate).format(format)}`;
  }

  return option;
};

export default comparisonDaterangeToString;
